// extracted by mini-css-extract-plugin
export default {"higher":"core_higher__apWde","lower":"core_lower__ggj0C"};